module.exports = __webpack_public_path__ + "img/หมึกกล้วย.7c16449b.png";